import {orderHands} from "../lib/whw/ranker";
import {Card} from './Entity/card';

export const AVAILABLE_GAMES = [
    'Texas Holdem',
    'Omaha Hi',
    'Razz',
];

const TYPE_RESULT_WIN = 'win';
const TYPE_RESULT_SPLIT = 'split';
export const AVAILABLE_RESULT = [
    'WIN',
    'SPLIT'
];

export class Game {

    constructor(players, board, gameType) {
        this.players = players;
        this.board = board;
        this.gameType = gameType;

        this.result = (function (players, board, gameType, AVAILABLE_GAMES) {
            if (!AVAILABLE_GAMES.includes(gameType)) {
                throw Error('Unsupported game type');
            }

            let handsNormalized = [];
            let boardNormalized = [];

            players.forEach(player => {
                let cards = [];
                player.hand.cards.forEach(card => {
                    cards.push(card.rank + card.suit);
                });
                handsNormalized.push({
                    id: player.id,
                    cards: cards,
                })
            });

            board.cards.forEach(card => {
                boardNormalized.push(card.rank + card.suit)
            });

            return orderHands(handsNormalized, boardNormalized, gameType);
        })(players, board, gameType, AVAILABLE_GAMES);
    }

    getTypeOfResult() {
        if (this.result[0].length === 1) {
            return TYPE_RESULT_WIN;
        } else {
            return TYPE_RESULT_SPLIT;
        }
    }

    getWinners() {
        let winners = this.result[0];
        let mapCards = function(cards) {
            return cards.map(function (card) {
                return new Card(card.rank, card.suit);
            });
        };

        let kickerRows = [];
        for (let i = 1 ; i < this.result.length ; i++) {
            if (this.result[i-1][0].description === this.result[i][0].description) {
                if (!kickerRows.includes(i-1)) {
                    kickerRows.push(i-1)
                }
                kickerRows.push(i);
            }
        }

        return {
            resultType: this.getTypeOfResult(),
            winnerResult: winners.map(function (winner) {
                let handName = winner.description;
                if (winner.highKicker && (winners.length===1 || kickerRows.includes(0))) {
                    handName += ', ' + Card.getNameByRank(winner.highKicker.rank) + ' kicker';
                }
                return {
                    playerId: winner.id,
                    cards: mapCards(winner.cards),
                    board: mapCards(winner.board),
                    result: mapCards(winner.playingCards),
                    handName: handName,
                    ranking: winner.ranking,
                }
            }),
            allResults: this.result.map(function (row, indexRow) {
                return row.map(function (player) {
                    let handName = player.description;
                    if (player.highKicker && (winners.length===1 || kickerRows.includes(indexRow))) {
                        handName += ', ' + Card.getNameByRank(player.highKicker.rank) + ' kicker';
                    }
                    return {
                        playerId: player.id,
                        cards: mapCards(player.cards),
                        board: mapCards(player.board),
                        result: mapCards(player.playingCards),
                        handName: handName,
                        ranking: player.ranking,
                    }
                })

            })
        }
    }


}